import { requestJSON } from './request'
import { Article } from './article'
import { Event } from './event'
import { Project } from './project'
import { Collection } from './collection'
import { ForumUser } from './user'

// category returned by API
export interface Category {
  id: number
  name: string
  featured: boolean
  logo: string
  icon_id: string
}

// used to parse results from search api
export enum ContentType {
  Article = 'Article',
  Event = 'Event',
  Project = 'Project',
  Collection = 'Collection',
  ForumUser = 'ForumUser'
}

export interface CategorySearchResult {
  id: number
  category: string
  type: ContentType
  data: Article | Event | Project | Collection | ForumUser
}

export async function getCategories (): Promise<Category[]> {
  return await requestJSON('/api/categories/')
}

export async function getCategory (categoryId: number): Promise<Category> {
  return await requestJSON(`/api/categories/${categoryId}/`)
}
